// ForgotPasswordModal.js
import React, { useState } from "react";
import axios from "axios";

const ForgotPasswordModal = ({ show, onClose, onNext }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  // Handle forgot password submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      alert("Email is required");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        "https://laravel.topdevit.com/api/forgot-password",
        new URLSearchParams({ email }), // x-www-form-urlencoded
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      );

      if (response.data?.token) {
        localStorage.setItem("reset_email", email);
        localStorage.setItem("reset_token", response.data.token);
        alert("Find Email successfully.");
        onNext(); // go to reset modal
      } else {
        alert("Unexpected response from server.");
      }
    } catch (error) {
      alert(error?.response?.data?.message || "Email not found!");
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <>
   <style>{`
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
}
`}</style>
    
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Forgot Password</h3>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label>Email</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button className="btn btn-outline-primary" type="submit" disabled={loading}>
            {loading ? "Sending..." : "Submit"}
          </button>
          <button
            className="btn btn-outline-danger ms-2"
            type="button"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
        </form>
      </div>
    </div>
    </>
  );
};

export default ForgotPasswordModal;
